import Head from "next/head";
import { DefaultSeo } from "next-seo";
import { getStrapiMedia } from "utils/media";
import "@/styles/index.scss";
import "@/styles/animation.scss";
import Script from "next/script";
import { useEffect } from "react";
import Custom500 from "./500";
import TagManager from "react-gtm-module";
import Providers from "components/providers";
import { initDatadogConfig } from "utils/datadog";
import { CMSUrls } from "utils/cmsHelper";
import { initIovation } from "utils/iovation";

const favIconUrl = CMSUrls.faviconUrl;

const MyApp = ({ Component, pageProps }) => {
  const { global } = pageProps;

  const initializeTagManagers = () => {
    const tagManagers = [
      { id: "GTM-PQ2NXWV" }, // Old GTM ID
      { id: "GTM-PVX89V7G" }, // New GTM ID
    ];

    tagManagers.forEach(tagManager => {
      TagManager.initialize({ gtmId: tagManager.id });
    });
  };

  useEffect(() => {
    initDatadogConfig();
    initializeTagManagers();
    initIovation();
  }, []);

  if (global === null) {
    return <Custom500 basic />;
  }

  if (global.attributes === undefined) {
    if (global.data === undefined) {
      return (
        <>
          <Component {...pageProps} />
        </>
      );
    }
    const { metadata } = global.data.attributes;

    return (
      <>
        <Head>
          <link rel="icon" href={getStrapiMedia(favIconUrl)} />
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1.0, user-scalable=no"
          />
        </Head>
        <DefaultSeo
          titleTemplate={`%s`}
          title="Page not found"
          description={metadata.metaDescription}
        />
        <Component {...pageProps} />
      </>
    );
  }

  const { metadata } = global.attributes;

  return (
    <>
      {/* Favicon */}
      <Head>
        <link rel="icon" href={getStrapiMedia(favIconUrl)} />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, user-scalable=no"
        />
      </Head>
      {/* Global site metadata */}
      <DefaultSeo
        titleTemplate={`%s`}
        title="Onmo"
        description={metadata.metaDescription}
      />
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=PQ2NXWV"
        strategy="afterInteractive"
      />
      <Providers global={global}>
        <Component {...pageProps} />
      </Providers>
    </>
  );
};

export default MyApp;
